<template>
  <v-card
    flat
  >
    <v-toolbar
      dark
      color="primary"
    >
      <v-btn
        icon
        dark
        @click="$emit('dialog-close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Add Funds</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          label="Amount"
          v-model="fundsIn"
          prefix="$"
          :rules="[rules.number]"
        ></v-text-field>
        <IntegrationSelect
          v-model="integrationId"
        ></IntegrationSelect>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="postFunds"
      >
        <v-icon left>
          mdi-cash-multiple
        </v-icon>
        Add Funds
      </v-btn>
      <v-btn
        v-if="user.admin"
        color="error"
        :loading="loading"
        :disabled="loading"
        @click="adminBalAdjust"
      >
        <v-icon left>
          mdi-shield-account-outline
        </v-icon>
        Adjust Balance
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import IntegrationSelect from '../IntegrationSelect.vue'

  export default {
    name: 'FundingForm',

    components: {
      IntegrationSelect
    },

    computed: {
      ...mapGetters([
        'user'
      ])
    },

    data: () => ({
      // From handling.
      loading: false,
      valid: true,

      // validation rules
      rules: {
        number: value => {
          return !isNaN(parseFloat(value)) && isFinite(value) && value >= 1 || 'Must be numeric.'
        }
      },

      // Funding
      integrationId: null,
      fundsIn: null
    }),

    methods: {
      ...mapActions([
        'updateUserWallet',
        'fundIn',
        'getTransactionHistory',
        'getWalletBalance'
      ]),

      // Add funds from Stripe integration.
      postFunds: function () {
        this.loading = true

        // Check validation
        this.valid = this.$refs.form.validate()

        if (this.valid == true) {
          let payload = {
            amount: this.fundsIn,
            notes: 'stripe funds in',
            userIntegrationId: this.integrationId
          }

          // Post.
          this.fundIn(payload).then(() => {
            this.getWalletBalance()
            this.getTransactionHistory()
          }).finally(() => {
            // Close everything out.
            this.$emit('dialog-close')
            this.loading = false
          })
        }
        else {
          this.loading = false
        }
      },

      // Admin method, directly adjusts the wallet balance.
      adminBalAdjust: function () {
        this.loading = true

        // Check validation
        this.valid = this.$refs.form.validate()


        if (this.valid == true) {
          // Add funds
          this.updateUserWallet({
            userId: this.user.id,
            amount: this.fundsIn
          }).then(() => {
            // Update balance and transaction state.
            this.getWalletBalance()
            this.getTransactionHistory()
          }).catch((error) => {
            console.error(error)
          }).finally(() => {
            // Close everything out.
            this.$emit('dialog-close')
            this.loading = false
          })
        }
        else {
          this.loading = false
        }
      },

      clearAndClose: function() {
        this.$emit('dialog-close')
      },

      dialogOpen: function() {
        this.$refs.form.reset()
      }
    }
  }
</script>
